import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '.'
import { WEB_APP_URL } from '../../env'
import { trackSignInCtaClicked } from '../../utils/client-events/tracking'

export default function WebAppLink({ onClick, eventTrackingProperties, ...rest }) {
  const handleClick = (event) => {
    trackSignInCtaClicked(event, eventTrackingProperties)
    onClick?.(event)
  }

  return (
    <Link
      data-testid={`signin-cta-${eventTrackingProperties.location}`}
      external
      messageId="cta.signIn"
      onClick={handleClick}
      to={WEB_APP_URL}
      {...rest}
    />
  )
}

WebAppLink.propTypes = {
  onClick: PropTypes.func,
  eventTrackingProperties: PropTypes.shape({
    location: PropTypes.string.isRequired,
  }).isRequired,
}
